import { Contact } from "./landing/contact/Contact"
import { Features } from "./landing/features/Features"
import { Footer } from "./landing/footer/Footer"
import { HowTo } from "./landing/howTo/HowTo"
import { Pricing } from "./landing/pricing/Pricing"
import { Title } from "./landing/title/Title"
import { LoadingOverlay } from "./components/LoadingOverlay"

export const AppContent = () => {
    return <>
        <LoadingOverlay />
        <Title />
        <HowTo />
        <Features />
        <Pricing />
        {/* <Portfolio />
        <SiteOffers />
        <UncleOnAWedding />
        <RockingAunt />
        <DomainInstructions/> */}
        <Contact/>
        <Footer />
    </>
}